import { AxiosResponse } from 'axios'

import { _axios } from './axios'

const BULK_CREATE_POLL = '/user-polls'

export const pollApi = () => {
  const bulkCreate = async (params: {
    userIDs: string[]
    version: number
  }): Promise<AxiosResponse<any>> => {
    return await _axios().post(BULK_CREATE_POLL, params)
  }

  return {
    bulkCreate,
  }
}
